import { type Community } from "@entities";
import { type ColumnProps } from "@shared/frontend/hyper-table/types";

export function buildCommunityColumns(
  volunteerCountById: Record<string, number>,
): ColumnProps<Community>[] {
  return [
    {
      field: "name",
      enableSorting: true,
      minSize: 220,
    },
    {
      field: "description",
      minSize: 280,
    },
    {
      field: "parentCommunity",
      caption: "קהילת אם",
      minSize: 180,
      cell: ({ row }) => row.original.parentCommunity?.name ?? "-",
    },
    {
      field: "associations",
      caption: "מתנדבים",
      minSize: 100,
      cell: ({ row }) => volunteerCountById[row.original.id] ?? "-",
    },
    {
      field: "createdAt",
      enableSorting: true,
      minSize: 160,
    },
  ];
}
